export const aboutLanding4 = {
  hero: {
    title: "Korszerű infrastruktúrát\népítünk európai\nvállalkozásoknak.",
    description:
      "Egy termékcég, amelynek küldetése, hogy egyszerűsítse, hogyan indítanak, értékesítenek és növekednek online a szolgáltató vállalkozások.",
  },
  mission: {
    badge: "KÜLDETÉSÜNK",
    text: "Millió tehetséges szakember, edzők, trénerek, terapeuták, alkotók, küzd az online üzletvitelhez szükséges technológiával. Kénytelenek összetákolni olyan eszközöket, amelyeket soha nem arra terveztek, hogy együtt működjenek.",
    text2:
      "A Bespire azért létezik, hogy ezt megváltoztassa. Egy AI-natív platformot építünk, amely minden szolgáltató szakembernek megadja a szükséges digitális infrastruktúrát: egységesen, intelligensen és gyönyörűen egyszerűen.",
    quote:
      '"Ha kiváló vagy abban, amit csinálsz, a technológiának könnyebbé kellene tennie, hogy vállalkozást építs köré."',
  },
  beliefs: {
    title: "Amiben\nhiszünk.",
    items: {
      productFirst: {
        title: "Termékközpontú",
        description:
          "Olyan eszközöket építünk, amelyek valós problémákat oldanak meg: nem pitch deckekhez készült funkciókat.",
      },
      europeanFirst: {
        title: "Európa-központú",
        description:
          "Európai üzleti kultúrára, adatvédelmi szabványokra és fizetési ökoszisztémákra tervezve.",
      },
      trustThroughQuality: {
        title: "Bizalom minőségen keresztül",
        description:
          "Bizalmat csiszolt, megbízható szoftver szállításával építünk: nem hype-pal.",
      },
      forRealBusinesses: {
        title: "Valódi vállalkozásoknak",
        description:
          "Minden, amit építünk, olyan embereket szolgál, akik értelmes munkát végeznek.",
      },
    },
  },
  approach: {
    badge: "MEGKÖZELÍTÉSÜNK",
    text: "A kiváló szoftvernek határozottnak kell lennie, nem túlterhelőnek. Platformunk alapértelmezés szerint okos döntéseket hoz, miközben teljes irányítást biztosít a testreszabáshoz.",
    text2:
      "Először az európai vállalkozásokra tervezünk: figyelembe véve a helyi fizetési módokat, az adatvédelmi elvárásokat és a kulturális árnyalatokat, amelyeket a globális platformok figyelmen kívül hagynak.",
  },
  cta: {
    title: "Csatlakozz az utazáshoz.",
    description:
      "A szolgáltató szakemberek üzleti infrastruktúrájának jövőjét építjük. Légy része.",
    demoButton: "Foglaljunk 30 percet",
    earlyAccessButton: "Indulj el ma",
  },
  finalCta: {
    title: "Készen állsz csatlakozni?",
    description:
      "A Bespire most elérhető. Indítsd el az oldalad 10 perc alatt, vagy beszélgessünk arról, hogy mi felépítsük neked.",
    startButton: "Indítsd el most: ingyen",
    callButton: "Foglaljunk 30 percet",
    footnote:
      "Bankkártya nem szükséges · 3 napos ingyenes próba · 30 ajándék AI kredit · Magyar nyelvű támogatás",
  },
  footer: {
    description:
      "Az AI-natív üzleti platform európai szolgáltató szakembereknek.",
    demoButton: "Foglaljunk 30 percet",
    platform: "PLATFORM",
    product: "Termék",
    useCases: "Felhasználási esetek",
    company: "VÁLLALAT",
    about: "Rólunk",
    contact: "Kapcsolat",
    legal: "JOGI",
    privacy: "Adatvédelem",
    terms: "Felhasználási feltételek",
    imprint: "Impresszum",
    copyright: "© {year} BESPIRE",
    builtInEurope: "KÉSZÜLT EURÓPÁBAN",
  },
};
